import { SVGProps } from "react"

import { IconProps } from "../nav-icons/icon.types.ts"

export const IconCertificates = ({ hovered, ...props }: IconProps) => {
  if (hovered) return <CertificatesHover {...props} />
  else return <CertificatesDefault {...props} />
}

const CertificatesDefault = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.5 4.5A1.5 1.5 0 0 0 19 3H4a2 2 0 0 0-2 2v10.5a2 2 0 0 0 2 2h7.5"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M5.5 8.5H9M5.5 11.5H9"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <circle cx={17} cy={11} r={5} stroke="currentColor" strokeWidth={2} />
    <path
      d="M14 15v6.13a.5.5 0 0 0 .752.431l1.996-1.164a.5.5 0 0 1 .504 0l1.996 1.164A.5.5 0 0 0 20 21.13V15"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
)

const CertificatesHover = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.5 4.5A1.5 1.5 0 0 0 19 3H4a2 2 0 0 0-2 2v10.5a2 2 0 0 0 2 2h7.5"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M5.5 8.5H9M5.5 11.5H9"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <circle
      cx={17}
      cy={11}
      r={5}
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M14 15v6.13a.5.5 0 0 0 .752.431l1.996-1.164a.5.5 0 0 1 .504 0l1.996 1.164A.5.5 0 0 0 20 21.13V15"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
)
